import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import {ScreenTransitionController} from "../base/ScreenTransitionController";
import $ from "jquery";

export class AIControlOledAppScreenTransition extends ScreenTransitionController {

  // Constructor
  constructor() {
    super();
    this.$currentScreen = null;
  }

  screen2InAnimation() {
    // Play slider
    this.screenTransitionTimeline.add(() => {
      app.playSlider();
    });
  }

  screen2OutLeftAnimation() {
    // Pause slider
    this.screenTransitionTimeline.add(() => {
      app.pauseSlider();
    });
  }

  screen2OutRightAnimation() {
    // Pause slider
    this.screenTransitionTimeline.add(() => {
      app.pauseSlider();
    }, '<');

    // Zoom in into slider
    this.screenTransitionTimeline.to(
      "#screen-2 #building-swiper .building-slider img",
      {
        scale: 1.25,
        duration: 1.5,
        ease: 'power2.in'
      },
      '<'
    )
    // this.screenTransitionTimeline.fromTo("#screen-2",
    //   {
    //     autoAlpha: 1.0
    //   },
    //   {
    //     autoAlpha: 0.0,
    //     duration: 1,
    //     ease: 'power1.out'
    //   }, '-=0.5');

    this.screenTransitionTimeline.fromTo("#screen-3",
      {
        autoAlpha: 0.0
      },
      {
        autoAlpha: 1.0,
        duration: 0.5,
        ease: 'power2.in',
      }, '-=0.5');

    // Vignette starts at full opacity when screen-3 appears
    // this.screenTransitionTimeline.set("#screen-3 .building-selector-element .vignette", {alpha: 1.0}, '<');

    // Zoom in into buildings
    this.screenTransitionTimeline.fromTo(
      '#algorithms-selectors-container .building-selector-element',
      {
        scale: 1.25,
        transformOrigin: '50% 50%'
      },
      {
        scale: 1,
        duration: 1.5,
        ease: 'power1.out'
      },
      '<'
    );

    // // Fade vignette out once the scale-up completes
    // this.screenTransitionTimeline.to("#screen-3 .building-selector-element .vignette",
    //   {
    //     alpha: 0.0, duration: 0.75,
    //     ease: 'none'
    //   },
    //   "-=1"
    // );
  }

  screen3InRightAnimation() {
    // this.screenTransitionTimeline.fromTo(this.$currentScreen,
    //   {alpha: 0.0}, {alpha: 1.0, duration: 0.40, ease: 'power1.in'});
    //
    // // Zoom in into buildings
    // this.screenTransitionTimeline.fromTo(
    //   '#algorithms-selectors-container .building-selector-element',
    //   {scale: 0.8, transformOrigin: '50% 50%'},
    //   {scale: 1, duration: 1.5, ease: 'power1.out'},
    //   '<'
    // );

    // Reset slider scale
    this.screenTransitionTimeline.set('#building-swiper .building-slider img', {scale: 1.0});
  }

  // screen3OutLeftAnimation() {
  //   // Zoom out from buildings
  //   this.screenTransitionTimeline.fromTo(
  //     this.$currentScreen.find(".building-selector-element"),
  //     {scale: 1.30, transformOrigin: '50% 50%'},
  //     {scale: 1.10, duration: 1.00, ease: 'power1.inOut'},
  //   );
  // }

  reset() {
  }
}
